import { render, staticRenderFns } from "./ColumnSettingsMobile.vue?vue&type=template&id=55a68788&"
import script from "./ColumnSettingsMobile.vue?vue&type=script&lang=js&"
export * from "./ColumnSettingsMobile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports